import React from 'react';
import { IconProps } from './types';

const ErrorIconOutline: React.FC<IconProps> = props => {
  const { className, size = 16, fillColor = '#E92C2C', onClick } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0013 5.83366C10.4596 5.83366 10.8346 6.20866 10.8346 6.66699V10.0003C10.8346 10.4587 10.4596 10.8337 10.0013 10.8337C9.54297 10.8337 9.16797 10.4587 9.16797 10.0003V6.66699C9.16797 6.20866 9.54297 5.83366 10.0013 5.83366ZM9.99297 1.66699C5.39297 1.66699 1.66797 5.40033 1.66797 10.0003C1.66797 14.6003 5.39297 18.3337 9.99297 18.3337C14.6013 18.3337 18.3346 14.6003 18.3346 10.0003C18.3346 5.40033 14.6013 1.66699 9.99297 1.66699ZM10.0013 16.667C6.31797 16.667 3.33464 13.6837 3.33464 10.0003C3.33464 6.31699 6.31797 3.33366 10.0013 3.33366C13.6846 3.33366 16.668 6.31699 16.668 10.0003C16.668 13.6837 13.6846 16.667 10.0013 16.667ZM10.8346 14.167H9.16797V12.5003H10.8346V14.167Z"
        fill="#E92C2C"
      />
    </svg>
  );
};

export default ErrorIconOutline;
